import React from "react";
import "../../../assets/css/container/main/AboutFactWeb.css";

export default function OperationPolicy() {
	return (
		<div className="about-container">
			<h1 className="about-title">운영정책</h1>

			<section className="about-section">
				<h2>운영 방향</h2>
				<p>
					FactWeb은 정치·이념적 중립을 유지하며,
					사실과 근거 중심의 검증 문화를 지향합니다.
					모든 이용자는 동등한 기준 아래 검증 대상이 됩니다.
				</p>
			</section>

			<section className="about-section">
				<h2>운영 개입</h2>
				<p>
					명백한 허위 정보, 증거 없는 단정,
					조직적 여론 조작이 확인될 경우
					운영진은 게시물 관리 및 제재 조치를 할 수 있습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>제재 기준</h2>
				<p>
					위반 정도에 따라 경고, 이용 제한,
					영구 정지 조치가 단계적으로 적용될 수 있으며,
					이는 서비스 보호를 위한 최소한의 조치입니다.
				</p>
			</section>
		</div>
	);
}
